module.exports = {"audiences":["alphaEnglishMembers","activityFeedMembers"],"experimentAllocation":{"alphaEnglishMembers":1,"activityFeedMembers":1},"defaultWeight":0,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/activityFeed.json
// module id = sp8J
// module chunks = 0